/* eslint-disable react-hooks/exhaustive-deps */
import "./Header.scss";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useEffect, useState, useRef } from "react";
import { getValue } from "@utils/lodash";
import { GetSpecificOrganization } from "@services/client-list.service";
import { clientLogout } from "@services/auth.service";

export default function Header(props: any) {
  const [user, setUser] = useState({});
  const [showSessionModal, setShowSessionModal] = useState(false);
  const inactivityTimerRef = useRef<NodeJS.Timeout | null>(null);
  const countdownTimerRef = useRef<NodeJS.Timeout | null>(null);
  const lastActivityTimeRef = useRef<number>(Date.now());
  const showSessionModalRef = useRef<boolean>(false);

  // Sync ref with state
  useEffect(() => {
    showSessionModalRef.current = showSessionModal;
  }, [showSessionModal]);

  const handleLogout = async () => {
    clearAllTimers();
    localStorage.removeItem("accessToken");
    localStorage.removeItem("user");
    localStorage.removeItem("op");
    localStorage.removeItem("organisation_logo");
    localStorage.removeItem("allTime");
    window.location.href = `/login`;
    let payload = {
      refresh_token: getValue(localStorage, `refreshToken`, ""),
    };
    await clientLogout(payload);
  };

  const clearAllTimers = () => {
    if (inactivityTimerRef.current) {
      clearInterval(inactivityTimerRef.current);
      inactivityTimerRef.current = null;
    }
    if (countdownTimerRef.current) {
      clearInterval(countdownTimerRef.current);
      countdownTimerRef.current = null;
    }
  };

  const resetInactivityTimer = () => {
    if (showSessionModalRef.current) return;
    lastActivityTimeRef.current = Date.now();
  };

  const showWarningModal = () => {
    setShowSessionModal(true);
    localStorage.clear();
  };

  const checkTokenExpiry = () => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      handleLogout();
      return false;
    }
    try {
      const { exp } = JSON.parse(atob(token.split(".")[1]));
      const expiryTime = exp * 1000;
      return Date.now() < expiryTime;
    } catch (error) {
      console.error("Token validation error:", error);
      return false;
    }
  };

  useEffect(() => {
    let user = JSON.parse(getValue(localStorage, `user`, ""));
    setUser(user);
    if (!getValue(localStorage, `organisation_logo`, "")) {
      if (getValue(user, `org_id`, "")) {
        getData(getValue(user, `org_id`, ""));
      }
    }
  }, []);

  const getData = async (id: string) => {
    try {
      let resp = await GetSpecificOrganization(id);
      if (resp) {
        let logo = getValue(resp, `data.data.organisation_logo`, "");
        if (logo) {
          localStorage.setItem("organisation_logo", logo);
        }
      }
    } catch (error) {
      console.error("Error fetching organization data:", error);
    }
  };

  useEffect(() => {
    if (!checkTokenExpiry()) {
      return;
    }
    const maxIdleTime = 1 * 60 * 60 * 1000; // 1 hour 
    const checkIdleTime = () => {
      if (showSessionModalRef.current) return;
      const now = Date.now();
      const diff = now - lastActivityTimeRef.current;
      if (diff >= maxIdleTime) {
        showWarningModal();
      }
    };

    const events = [
      "mousedown",
      "mousemove",
      "keypress",
      "scroll",
      "touchstart",
      "click",
    ];
    events.forEach((event) => {
      window.addEventListener(event, resetInactivityTimer, { passive: true });
    });

    window.addEventListener("focus", resetInactivityTimer);
    window.addEventListener("blur", resetInactivityTimer);
    document.addEventListener("visibilitychange", resetInactivityTimer);

    // Start checking idle time
    inactivityTimerRef.current = setInterval(checkIdleTime, 1000);

    // Initial activity mark
    resetInactivityTimer();

    return () => {
      clearAllTimers();
      events.forEach((event) => {
        window.removeEventListener(event, resetInactivityTimer);
      });

      window.removeEventListener("focus", resetInactivityTimer);
      window.removeEventListener("blur", resetInactivityTimer);
      document.removeEventListener("visibilitychange", resetInactivityTimer);
    };
  }, []);

  const toggleTab = () => {
    var mainWrapper = document.getElementsByClassName("main-wrapper")[0];
    if (mainWrapper.classList.contains("sidebar-isOpen")) {
      mainWrapper.classList.remove("sidebar-isOpen");
      props.setIsOpenFirstLevel(null);
      props.setIsOpenSecondLevel(null);
      props.setMenuActive(true);
    } else {
      mainWrapper.classList.add("sidebar-isOpen");
      props.setMenuActive(false);
    }
  };

  return (
    <header className="header-wrapper">
      <div className="container-fluid d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center cursor-pointer">
          {/* <a className="submenu-toggler-holder" onClick={() => toggleTab()} > */}
          <a
            href="#toggle"
            onClick={(e) => {
              e.preventDefault();
              toggleTab();
            }}
            className="submenu-toggler-holder"
            role="button"
            aria-pressed="false"
          >
            <img src="/images/toggler-icon.svg" className="img-fluid " alt="" />
          </a>

          <img
            src={
              getValue(localStorage, `organisation_logo`, "")
                ? getValue(localStorage, `organisation_logo`, "")
                : "/images/lexcare_logo.jpeg"
            }
            width="173"
            height="52"
            className="img-fluid header-wrapper__logo"
            alt=""
          />
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <div className="bulk-dropdown">
            <UncontrolledDropdown>
              <DropdownToggle caret>
                <div className="header__dropdown m-0">
                  <div className="dropdown-content d-flex cursor-pointer">
                    <span className="m-auto">
                      {getValue(user, `email`, "").charAt(0).length > 0
                        ? getValue(user, `email`, "").charAt(0).toUpperCase()
                        : "A"}
                    </span>
                  </div>
                </div>
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem header>
                  <h4>Accounts</h4>
                </DropdownItem>
                <DropdownItem>
                  <div className="header__dropdown m-0  text-center d-flex">
                    <div className="dropdown-content d-flex cursor-pointer">
                      <span className="m-auto">
                        {getValue(user, `email`, "").charAt(0).length > 0
                          ? getValue(user, `email`, "").charAt(0).toUpperCase()
                          : "A"}
                      </span>
                    </div>
                  </div>
                </DropdownItem>
                <DropdownItem>
                  <div className="px-2">
                    <p>{getValue(user, `email`, "")}</p>
                    <button className="header-btn">Ascent Account</button>
                  </div>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem>
                  <div className="text-center">
                    <button
                      className="ascent-button ascent-button--secondary ascent-button--header-buttons"
                      onClick={handleLogout}
                    >
                      Sign out
                    </button>
                  </div>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </div>
      </div>

      {showSessionModal && (
        <div className="session-modal-overlay">
          <div className="session-modal-dialog">
            <div className="session-modal-content">
              <div className="session-modal-header">
                <h5>Session Expired!</h5>
              </div>

              <div className="session-modal-body">
                <p>
                  Your session has expired due to inactivity. Please log in
                  again.
                </p>
              </div>

              <div className="session-modal-footer">
                <button className="session-btn-danger" onClick={handleLogout}>
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
